export default "__VITE_ASSET__5543497b__"